"use client";

import { useBookmarkStore } from "@/app/stores/bookmark-store";

/**
 * Hook for managing bookmarks (vehicles and contact persons)
 * Provides convenient wrapper functions around the bookmark store
 */
export function useBookmark() {
  const store = useBookmarkStore();

  return {
    // Vehicle bookmarks
    vehicleIds: store.vehicleIds,
    toggleVehicleBookmark: store.toggleVehicleBookmark,
    isVehicleBookmarked: store.isVehicleBookmarked,
    addVehicleBookmark: store.addVehicleBookmark,
    removeVehicleBookmark: store.removeVehicleBookmark,

    // Contact person bookmarks
    contactPersonIds: store.contactPersonIds,
    toggleContactPersonBookmark: store.toggleContactPersonBookmark,
    isContactPersonBookmarked: store.isContactPersonBookmarked,
    addContactPersonBookmark: store.addContactPersonBookmark,
    removeContactPersonBookmark: store.removeContactPersonBookmark,

    // Utility
    clearAllBookmarks: store.clearAllBookmarks,
  };
}
